import { render, staticRenderFns } from "./peopleManageMentDialog.vue?vue&type=template&id=b965f31a&"
import script from "./peopleManageMentDialog.vue?vue&type=script&lang=js&"
export * from "./peopleManageMentDialog.vue?vue&type=script&lang=js&"
import style0 from "./peopleManageMentDialog.vue?vue&type=style&index=0&id=b965f31a&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports